import { faMoneyBillWave, faPlus, faUserGraduate, faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cn from 'classnames';
import { useEntryFormContext } from 'context/EntryFormContext';
import { Button } from 'components/Button';
import { Input } from 'components/Input';
import styles from 'pages/Schedule/CreateEntry/CreateEntry.scss';

export const CoachFields = () => {
  const { form, allCoaches } = useEntryFormContext();

  const coaches = form.values.coaches;
  const error = form.touched.coaches && form.errors.coaches;

  const updateCoachData = (index, updateFunction) => {
    const updatedCoaches = [...coaches];
    updatedCoaches[index] = updateFunction(updatedCoaches[index]);
    form.setFieldValue('coaches', updatedCoaches);
  };

  const handleCoachChange = ({ target: { value } }, index) => {
    updateCoachData(index, (coach) => ({ ...coach, coach: value }));
  };

  const handlePriceChange = ({ target: { value } }, index) => {
    updateCoachData(index, (coach) => {
      const isNumeric = /^\d+$/g.test(value.trim());
      return {
        ...coach,
        price: isNumeric ? value : null,
      };
    });
  };

  const addField = () => {
    const newCoaches = [...coaches, { coach: '', price: '' }];
    form.setFieldValue('coaches', newCoaches);
  };

  const removeField = (index) => {
    const updatedCoaches = [...coaches];
    updatedCoaches.splice(index, 1);
    form.setFieldValue('coaches', updatedCoaches);
  };

  const addPayment = (index) => {
    updateCoachData(index, ({ coach }) => ({ coach, price: null }));
  };

  const removePayment = (index) => {
    updateCoachData(index, ({ coach }) => ({ coach }));
  };

  const coachesSuggestions = allCoaches.map(({ surname, name }) => `${surname} ${name}`);

  return (
    <div className={cn(styles.personFields, styles.coaches)}>
      <div className={cn(styles.header, styles.main)}>
        <div className={styles.label}>
          <div className={styles.icon}>
            <FontAwesomeIcon icon={faUserGraduate} />
          </div>
          Тренери
        </div>
        <Button className={styles.actionBtn} onClick={addField} noStyle>
          <FontAwesomeIcon icon={faPlus} /> Додати тренера
        </Button>
      </div>

      <div className={styles.list}>
        {coaches.map((coachData, index) => (
          <div className={styles.person} key={index}>
            <div className={styles.header}>
              <div className={styles.label}>
                <span className={styles.icon}>{index + 1}</span>
                Тренер {index + 1}
              </div>
              <div className={styles.buttons}>
                {!coachData?.price && coachData?.price !== null && (
                  <Button className={styles.actionBtn} onClick={() => addPayment(index)} noStyle>
                    <FontAwesomeIcon icon={faPlus} /> Оплата
                  </Button>
                )}
                {index > 0 && (
                  <Button className={cn(styles.actionBtn, styles.deleteBtn)} onClick={() => removeField(index)} noStyle>
                    <FontAwesomeIcon icon={faXmark} />
                  </Button>
                )}
              </div>
            </div>

            <div className={styles.inputField}>
              <Input
                className={styles.input}
                value={coachData?.coach || ''}
                name={`coaches.${index}.coach`}
                placeholder='Введіть тренера'
                onChange={(e) => handleCoachChange(e, index)}
                suggestions={coachesSuggestions}
              />
            </div>

            {(coachData?.price || coachData?.price === null) && (
              <div className={styles.paymentBlock}>
                <FontAwesomeIcon icon={faMoneyBillWave} />
                <Input
                  className={styles.paymentInput}
                  value={coachData?.price || ''}
                  name={`coaches.${index}.price`}
                  placeholder='Сума'
                  onChange={(e) => handlePriceChange(e, index)}
                  invalid={!!error}
                  errorText={error}
                />
                <button
                  type='button'
                  className={cn(styles.actionBtn, styles.deleteBtn)}
                  onClick={() => removePayment(index)}
                  aria-label='Прибрати оплату'
                >
                  <FontAwesomeIcon icon={faXmark} />
                </button>
              </div>
            )}
          </div>
        ))}
      </div>

      {error && <div className={styles.errorMessage}>{error}</div>}
    </div>
  );
};
